import React from "react";
import { useReveal } from "../../hooks/useReveal";
import { Ornament } from "../Ornaments";

const items = [
  "You've grown tired of frameworks that address the symptom but not the system — and you sense there's a more fundamental level available to you.",
  "You feel the world shifting energetically and situationally, and your body is registering something your mind hasn't fully named or mapped yet.",
  "You're done guessing at who you are. You want to know — and to consciously cultivate who you are becoming, with the full participation of your body.",
  "You're ready to treat your biology not as a limitation but as a programmable system — one that, when brought into coherence, can reorganize, expand, and carry you into the life you're building.",
];

const ForWhomCard = ({ text, index }) => {
  const rv = useReveal();
  return (
    <div
      ref={rv.ref}
      className={`card-gold-left reveal ${rv.inView ? "in-view" : ""}`}
      style={{ transitionDelay: `${index * 80}ms` }}
      data-testid={`forwhom-card-${index}`}
    >
      <div style={{ display: "flex", gap: "1.25rem", alignItems: "flex-start" }}>
        <span className="numeral" style={{ fontSize: "1.5rem", color: "var(--gold)" }}>
          {String(index + 1).padStart(2, "0")}
        </span>
        <p className="font-body" style={{ color: "var(--text)", fontSize: "1rem", lineHeight: 1.8 }}>
          {text}
        </p>
      </div>
    </div>
  );
};

export const ForWhom = () => {
  const head = useReveal();
  return (
    <section id="for-whom" className="section" data-testid="forwhom-section" style={{ position: "relative" }}>
      <div className="section-inner">
        <div ref={head.ref} className={`reveal ${head.inView ? "in-view" : ""}`} style={{ maxWidth: 780, marginBottom: "3rem" }}>
          <Ornament />
          <p className="font-heading" style={{ color: "var(--gold)", fontSize: "0.7rem", letterSpacing: "0.4em", marginBottom: "1rem" }}>
            Is This For You
          </p>
          <h2 className="section-title" data-testid="forwhom-title">You May Be Ready If...</h2>
        </div>

        <div className="fw-grid">
          {items.map((text, i) => (
            <ForWhomCard key={text} text={text} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
